import React, { useCallback, useMemo } from 'react';
import { default as AnalyticsReactContext } from '@atlaskit/analytics-next-stable-react-context';
import { useAnalyticsContext } from '../../hooks/useAnalyticsContext';
import { useTrackedRef } from '../../hooks/useTrackedRef';

const AnalyticsContext = ({
  data,
  children
}) => {
  const dataRef = useTrackedRef(data);
  const analyticsContext = useAnalyticsContext();
  const getAtlaskitAnalyticsContext = useCallback(() => {
    return [...analyticsContext.getAtlaskitAnalyticsContext(), dataRef.current];
  }, [analyticsContext, dataRef]);
  const value = useMemo(() => ({
    getAtlaskitAnalyticsContext,
    getAtlaskitAnalyticsEventHandlers: analyticsContext.getAtlaskitAnalyticsEventHandlers
  }), [analyticsContext, getAtlaskitAnalyticsContext]);
  return /*#__PURE__*/React.createElement(AnalyticsReactContext.Provider, {
    value: value
  }, children);
};

export default AnalyticsContext;